(function () {
	'use strict';

	var RECENT_KEY = 'm1o2:recently';
	var MAX_RECENT = 8;

	function readRecent() {
		try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; }
	}
	function writeRecent(list) {
		try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
	}

	function ajaxAdd(form) {
		var btn = form.querySelector('[type="submit"], .m1o2-pdp-cm__cart, .m1o2-pdp-cm__rv-cart');
		var orig = btn ? btn.innerHTML : '';
		if (btn) { btn.disabled = true; btn.textContent = 'ADDING…'; }
		fetch('/cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
			body: new URLSearchParams(new FormData(form)).toString()
		}).then(function (r) { return r.json(); }).then(function () {
			if (btn) { btn.textContent = 'ADDED ✓'; }
			document.dispatchEvent(new CustomEvent('m1o2:cart:added'));
			setTimeout(function () { if (btn) { btn.disabled = false; btn.innerHTML = orig; } }, 1500);
		}).catch(function () {
			if (btn) { btn.disabled = false; btn.innerHTML = orig; }
			form.submit();
		});
	}

	function wireForm(form) {
		/* per-card variant pills */
		var idInput = form.querySelector('[data-cm-id]');
		var priceText = form.querySelector('[data-cm-price-text]');
		var cartBtn = form.querySelector('.m1o2-pdp-cm__cart');
		var cartLabel = form.querySelector('[data-cm-cart-label]');
		var card = form.closest('.m1o2-pdp-cm__card') || form;
		var img = card.querySelector('[data-cm-img]');
		var copy = card.querySelector('[data-cm-copy]');
		var lead = card.querySelector('[data-cm-lead]');
		var links = Array.prototype.slice.call(card.querySelectorAll('[data-cm-link]'));
		Array.prototype.slice.call(form.querySelectorAll('.m1o2-pdp-cm__pill')).forEach(function (pill) {
			pill.addEventListener('click', function () {
				form.querySelectorAll('.m1o2-pdp-cm__pill').forEach(function (p) { p.classList.remove('is-active'); p.setAttribute('aria-pressed', 'false'); });
				pill.classList.add('is-active'); pill.setAttribute('aria-pressed', 'true');
				if (idInput) idInput.value = pill.getAttribute('data-cm-variant');
				if (priceText) priceText.textContent = pill.getAttribute('data-cm-price');
				/* Variant content: image (kept when the variant has none), short copy, links, stock */
				var vImg = pill.getAttribute('data-cm-img');
				if (img && vImg) { img.src = vImg; }
				var vDesc = pill.getAttribute('data-cm-desc');
				if (copy && vDesc) { copy.textContent = vDesc; }
				var vLead = pill.getAttribute('data-cm-lead');
				if (lead && vLead) { lead.textContent = vLead; }
				var vUrl = pill.getAttribute('data-cm-url');
				if (vUrl) { links.forEach(function (a) { a.setAttribute('href', vUrl); }); }
				var available = pill.getAttribute('data-cm-available') === 'true';
				if (cartBtn) { cartBtn.disabled = !available; cartBtn.classList.toggle('is-soldout', !available); }
				if (cartLabel) { cartLabel.textContent = available ? 'ADD TO CART - ' : 'SOLD OUT'; }
				if (priceText) { priceText.hidden = !available; }
			});
		});
		form.addEventListener('submit', function (e) { e.preventDefault(); ajaxAdd(form); });
	}

	/* Recently Viewed: localStorage keeps only product handles. Each card is fetched from the
	   card-only view (templates/product.m1o2-card.liquid), i.e. the same server-rendered
	   snippets/m1o2-pdp-card as the Related tab, so both tabs match and price, stock, copy and
	   pills are live rather than a snapshot. Stored values are untrusted (any script on the
	   origin can write them), so only plain handles are requested. */
	var HANDLE = /^[a-z0-9][a-z0-9-]*$/;

	function fetchCard(handle) {
		var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
		return fetch(root + 'products/' + encodeURIComponent(handle) + '?view=m1o2-card', { credentials: 'same-origin' })
			.then(function (r) { return r.ok ? r.text() : ''; })
			.then(function (html) {
				var tpl = document.createElement('template');
				tpl.innerHTML = html;
				return tpl.content.querySelector('.m1o2-pdp-cm__card');
			})
			.catch(function () { return null; });
	}

	function initSection(section) {
		/* record current product */
		var cur = null;
		var curEl = section.querySelector('[data-cm-current]');
		if (curEl) { try { cur = JSON.parse(curEl.textContent); } catch (e) { cur = null; } }
		var list = readRecent();
		if (cur && cur.handle) {
			list = list.filter(function (x) { return x && x.handle !== cur.handle; });
			list.unshift({ handle: cur.handle });
			if (list.length > MAX_RECENT) list = list.slice(0, MAX_RECENT);
			writeRecent(list);
		}

		/* wire related forms */
		Array.prototype.slice.call(section.querySelectorAll('[data-cm-panel="related"] [data-cm-add]')).forEach(wireForm);

		/* build recently-viewed */
		var rvList = section.querySelector('[data-cm-recent-list]');
		var rvEmpty = section.querySelector('[data-cm-recent-empty]');
		if (rvList) {
			var others = list
				.map(function (x) { return x && x.handle; })
				.filter(function (h) { return typeof h === 'string' && HANDLE.test(h) && (!cur || h !== cur.handle); })
				.slice(0, 3);
			Promise.all(others.map(fetchCard)).then(function (cards) {
				var shown = 0;
				cards.forEach(function (card) {
					if (!card) return; /* product deleted or unpublished since it was viewed */
					rvList.appendChild(card);
					var f = card.querySelector('[data-cm-add]');
					if (f) wireForm(f);
					shown += 1;
				});
				if (shown === 0 && rvEmpty) rvEmpty.hidden = false;
			});
		}

		/* tabs */
		var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-cm-tab]'));
		tabs.forEach(function (tab) {
			tab.addEventListener('click', function () {
				var name = tab.getAttribute('data-cm-tab');
				tabs.forEach(function (t) {
					var on = t === tab;
					t.classList.toggle('is-active', on);
					t.setAttribute('aria-selected', on ? 'true' : 'false');
					t.tabIndex = on ? 0 : -1;
				});
				Array.prototype.slice.call(section.querySelectorAll('[data-cm-panel]')).forEach(function (panel) {
					panel.hidden = panel.getAttribute('data-cm-panel') !== name;
				});
			});
			tab.addEventListener('keydown', function (e) {
				var idx = tabs.indexOf(tab);
				if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
					e.preventDefault();
					var next = e.key === 'ArrowRight' ? tabs[idx + 1] || tabs[0] : tabs[idx - 1] || tabs[tabs.length - 1];
					next.focus(); next.click();
				}
			});
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		Array.prototype.slice.call(document.querySelectorAll('.m1o2-pdp-cm')).forEach(initSection);
	});
})();
